import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import PagedResponse from "@/types/sv-data/PagedResponse";
import { LabelPagedResonse } from "@/store/labels/types";
import { AxiosInstance, } from "axios";
import { Label, LabelType } from "@/store/labels/types";
import { PaginatedSearchRequest } from "@/mixins/PaginatedSearch";

const LabelRoute = "/Label";

class LabelApi {
	private axios: AxiosInstance;
	private axiosJson: AxiosInstance;

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
	}

	public async createOrUpdateLabel(label: Label): Promise<number> {
		const { data } = await this.axiosJson.put(`${LabelRoute}/CreateOrUpdate`, label);
		return data;
	}

	public async deleteLabel(labelId: number): Promise<boolean> {
		const { data } = await this.axios.delete(`${LabelRoute}/Delete/${labelId}`);
		console.log(data);
		return data;
	}

	public async getLabels(paginatedSearchRequest: PaginatedSearchRequest): Promise<PagedResponse> {
		const { data } = await this.axiosJson.get(`${LabelRoute}/GetLabels`, {
			params: paginatedSearchRequest.params,
			cancelToken: paginatedSearchRequest.cancelToken
		});

		return data;
	}

	public async getLabelTypes(): Promise<LabelType[]> {
		const { data } = await this.axios.get(`${LabelRoute}/GetLabelTypes`);
		return data;
	}

	public async GetLabelsForObject(objectId: number, labelType: number): Promise<Label[]> {
		const { data } = await this.axios.get(`${LabelRoute}/GetLabelsForObject`, {
			params: {
				objectId,
				labelType
			}
		});
		return data;
	}

	public async GetLabelsByLabelType(request: PaginatedSearchRequest): Promise<LabelPagedResonse> {
		const { data } = await this.axios.get(`${LabelRoute}/GetLabelsByLabelType`, request);
		return data;
	}
}

const labelApi = new LabelApi();
export default labelApi;
